import { GET_LIVE_SESSIONS, GET_PROJECTS_LIST, GET_VENDOR_USERS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type SessionUsages = {
  projectId: String;
  entityType: String;
  entityId: String;
  hasAttended: string | boolean;
  isActive: string | boolean;
  joined_at: [Date | null, Date | null];
  left_at: [Date | null, Date | null];  
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const sessionUsagesInitialValues: SessionUsages = {
  projectId: "",
  entityType: "",
  entityId: "",
  hasAttended: "",
  isActive: "",
  joined_at: [null, null],
  left_at: [null, null],
  created_at: [null, null],
  updated_at: [null, null],
};

export const sessionUsagesMandatoryFields = [];

export const sessionUsagesValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  joined_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  left_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const sessionUsagesProperties = [
  
 {
    id: "projectId",
    type: "single-select-search",
    label: "Project",
    // list: "",
    keyValue: { label: "name", value: "id" },
    query: GET_PROJECTS_LIST,
    gqlKey: "getProjects",
    dataKey: "projects",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
// {
//     id: "entityId",
//     type: "text",
//     label: "Entity ID",
//     Placeholder: "Enter Entity ID",
//     className: "name-styles",
//     breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
//     required: false,
// },
// {
//     id: "entityType",
//     type: "text",
//     label: "Entity Type",
//     Placeholder: "Enter Entity Type",
//     className: "name-styles",
//     breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
//     required: false,
// },
{
    id: "entityType",
    type: "normal-select",
    label: "Entity Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "liveclass.teachers", value: "liveclass.teachers" },
      { label: "liveclass.nlearn3_students", value: "liveclass.nlearn3_students" },
    ],
    hideNone: false,
},
{
    id: "hasAttended",
    type: "normal-select",
    label: "Has Attended",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
},
{
    id: "isActive",
    type: "normal-select",
    label: "Is Active",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
},
  {
    id: "joined_at",
    type: "date-range-picker",
    label: "Joined Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "left_at",
    type: "date-range-picker",
    label: "Left Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
